module.exports = __webpack_public_path__ + "img/link_arrow_back.e1d54bd2.svg";